<template>
  <div style="margin:5%;">
    <b-button size="sm" variant="outline-primary" @click="cleanAllErrors">Effacer tout</b-button>
    <b-table striped hover :items="items"></b-table>
  </div>
</template>
<script>

import server from '../../api/server.vue'

const items = [
  { State: 'Loading'},
]

export default {
  name: 'Errors',
  data() {
    return {
        items: items
      };
  },
  methods: {
    cleanAllErrors: function () {
      server.cleanAllErrors().then( () => {
        server.getAllErrors().then( response => 
        {
          this.items = response.data
          //_cellVariants: { isActive: 'success', age: 'info', first_name: 'warning' }
        })
      })
    }
  },
  mounted: function () {
    // `this` est une référence à l'instance de vm
    server.getAllErrors().then( response => 
    {
      this.items = response.data
      //_cellVariants: { isActive: 'success', age: 'info', first_name: 'warning' }
    })
  }
};
</script>



// WEBPACK FOOTER //
// src/components/settings/errors.vue